import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import ProductsHero from './components/ProductsHero';
import SeriesSection from './components/SeriesSection';
import ProductsCTA from './components/ProductsCTA';
import JsonLd from '../../components/base/JsonLd';

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://example.com';

const productsJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    '@id': `${SITE_URL}/products`,
    url: `${SITE_URL}/products`,
    name: 'Precision Optical Lamp Products | ONOPTO 普像光学',
    description:
      'Browse the full ONOPTO product catalog — Mercury-Xenon lamps, Heating lamps (RTP/EPI/Thin Film/PIW&SPM), and UV lamps for semiconductor, medical imaging, and industrial applications.',
    isPartOf: { '@id': SITE_URL },
    inLanguage: 'en',
    dateModified: '2026-03-31',
    publisher: {
      '@type': 'Organization',
      name: 'ONOPTO 普像光学',
      url: SITE_URL,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'ONOPTO Precision Optical Lamp Series',
    description:
      'Complete range of precision optical lamps including Mercury-Xenon series, Semiconductor Heating lamps, and UV lamps.',
    url: `${SITE_URL}/products`,
    numberOfItems: 3,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Mercury-Xenon Lamp Series',
        description:
          'High-intensity mercury-xenon discharge lamps for semiconductor inspection, exposure, and low-noise imaging: Xeno-inspec, Xeno-low noise, WEE, 350W–5000W, and SHP ultra-high-power variants.',
        url: `${SITE_URL}/products`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Semiconductor Heating Lamp Series',
        description:
          'Tungsten halogen heating lamps for RTP, EPI, Thin Film, PIW and SPM equipment — compatible with AMAT, Mattson, and ASM platforms.',
        url: `${SITE_URL}/products`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'UV Lamp Series',
        description:
          'Fluorescent UV lamps, alignment lamps, and debonding lamps for display panel manufacturing and semiconductor photolithography.',
        url: `${SITE_URL}/products`,
      },
    ],
  },
];

/** 精准滚动，自动扣除固定导航栏高度 */
export function scrollToSection(id: string) {
  const el = document.getElementById(id);
  if (!el) return;
  const navbarHeight = 80;
  const top = el.getBoundingClientRect().top + window.scrollY - navbarHeight;
  window.scrollTo({ top, behavior: 'smooth' });
}

export default function ProductsPage() {
  useEffect(() => {
    if (sessionStorage.getItem('scrollToSeries') === '1') {
      sessionStorage.removeItem('scrollToSeries');
      setTimeout(() => scrollToSection('series'), 80);
    } else if (sessionStorage.getItem('scrollToCTA') === '1') {
      sessionStorage.removeItem('scrollToCTA');
      setTimeout(() => scrollToSection('cta'), 80);
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }
  }, []);

  return (
    <div className="min-h-screen font-sans antialiased">
      <JsonLd data={productsJsonLd} />
      <Navbar />
      <main>
        <ProductsHero />
        <div id="series">
          <SeriesSection />
        </div>
        <div id="cta">
          <ProductsCTA />
        </div>
      </main>
      <Footer />
    </div>
  );
}
